export default __webpack_public_path__ + "static/media/gallery159_4.a8a89e92.png";